import { render, staticRenderFns } from "./ThSortable.vue?vue&type=template&id=a21af736&scoped=true&"
import script from "./ThSortable.vue?vue&type=script&lang=js&"
export * from "./ThSortable.vue?vue&type=script&lang=js&"
import style0 from "./ThSortable.vue?vue&type=style&index=0&id=a21af736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21af736",
  null
  
)

export default component.exports